import type { IAssetConstructorParams } from "@services/sdk";

class Asset {
	public static Construct(params: IAssetConstructorParams): Asset {
		return new Asset(params);
	}

	responseData: IAssetConstructorParams;

	constructor(params: IAssetConstructorParams) {
		this.responseData = params;
	}

	get url(): string {
		return `https:${this.responseData.url}`;
	}
}

export default Asset;
